import React, { useEffect } from "react";
import { useTheme } from "styled-components";
import { IDocViewProps } from "../../@interfaces";
import CloseButton from "../closebutton";
import Loading from "../loading";
import { Container, PDFContainer } from "./styles";
import useIsMobile from "../../hooks/useIsMobile";

const DocView: React.FC<IDocViewProps> = ({ file, closeView }) => {
  const { colors } = useTheme();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!file || !isMobile) return;

    let url: string;
    let fileName = `documento-${Date.now()}.pdf`;

    if (typeof file === "object") {
      url = URL.createObjectURL(file);
    } else {
      url = file;
    }

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    closeView();
  }, [file, isMobile, closeView]);

  return (
    <Container>
      <CloseButton
        handleClose={closeView}
        color={"#fff"}
        size={20}
        styles={{ position: "absolute", top: "5px", right: "5px" }}
      />

      {file ? (
        <PDFContainer>
          {isMobile ? (
            <div className="flex justify-center items-center h-full flex-col gap-4 text-white">
              <p>Não foi possível abrir automaticamente</p>
            </div>
          ) : (
            <iframe
              title="pdf"
              src={
                typeof file === "object"
                  ? `/web/viewer.html?file=${window.URL.createObjectURL(file)}`
                  : file
              }
              width="100%"
              height="100%"
            />
          )}
        </PDFContainer>
      ) : (
        <Loading color={colors.white} />
      )}
    </Container>
  );
};

export default DocView;